export const getRentableCircles=(state)=>{
    return Object.keys(state.rentable_circles.circles).length? state.rentable_circles.circles : undefined;
}
export const isFetchingRentableCircles = (state) => {
    return state.rentable_circles.loading;
};

export const loadingInitialCirclesList=(state)=>{
    return (
        isFetchingRentableCircles(state) && (Object.keys(state.rentable_circles.circles).length === 0)
    )
}